module.exports = __webpack_public_path__ + "img/bg_qianwan.5dad6b47.png";